/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OffsetInputs */

const en_offset = /** @type {(inputs: OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset`)
};

const fr_offset = /** @type {(inputs: OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décalage`)
};

const de_offset = /** @type {(inputs: OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset`)
};

const it_offset = /** @type {(inputs: OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset`)
};

const ru_offset = /** @type {(inputs: OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компенсировать`)
};

const es_offset = /** @type {(inputs: OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compensar`)
};

const zh_cn2_offset = /** @type {(inputs: OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抵消`)
};

const ja_offset = /** @type {(inputs: OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフセット`)
};

const hi_offset = /** @type {(inputs: OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओफ़्सेट`)
};

const pt_pt2_offset = /** @type {(inputs: OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desvio`)
};

/**
* | output |
* | --- |
* | "Offset" |
*
* @param {OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offset = /** @type {((inputs?: OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offset(inputs)
	if (locale === "de") return de_offset(inputs)
	if (locale === "it") return it_offset(inputs)
	if (locale === "ru") return ru_offset(inputs)
	if (locale === "es") return es_offset(inputs)
	if (locale === "zh-CN") return zh_cn2_offset(inputs)
	if (locale === "ja") return ja_offset(inputs)
	if (locale === "hi") return hi_offset(inputs)
	if (locale === "pt-PT") return pt_pt2_offset(inputs)
	return en_offset(inputs)
});